// ---------------------------------------------------------------
// notificationService.js — Notificaciones de mensajes.
// Colección `notifications`: { toUid: uid | "all", title, body,
// fromName, createdAt, readBy: {uid:true}, hiddenBy: {uid:true} }.
// Sólo el administrador crea; cada usuario lee las suyas y las
// globales, y puede marcarlas como leídas u ocultarlas (borrar)
// SÓLO para sí mismo.
// ---------------------------------------------------------------
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase";

export function sendNotification({ toUid, title, body, fromName }) {
  return addDoc(collection(db, "notifications"), {
    toUid: toUid || "all",
    title: title.trim(),
    body: body.trim(),
    fromName: fromName || "Administración",
    createdAt: serverTimestamp(),
    readBy: {},
    hiddenBy: {},
  });
}

/** Marca un mensaje como leído para este usuario */
export function markNotificationRead(id, uid) {
  return updateDoc(doc(db, "notifications", id), { [`readBy.${uid}`]: true });
}

/** "Borra" un mensaje para este usuario (lo oculta sólo para él) */
export function hideNotification(id, uid) {
  return updateDoc(doc(db, "notifications", id), { [`hiddenBy.${uid}`]: true });
}

/** Mensajes dirigidos a este usuario o a todos, más recientes primero.
 *  Se ordena en cliente para no necesitar un índice compuesto. */
export function subscribeNotifications(uid, onData, onError) {
  const q = query(
    collection(db, "notifications"),
    where("toUid", "in", [uid, "all"])
  );
  return onSnapshot(
    q,
    (snap) => {
      const docs = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      docs.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
      onData(docs.slice(0, 30));
    },
    onError
  );
}
